import React, { useState } from "react";
import ToolMessage from "./ToolMessage";
import "./ToolGroup.css";

const STEP_LABELS = {
  read: "Reading your page...",
  inspect_dom: "Looking around...",
  inspect_styles: "Looking around...",
  edit: "Working magic...",
  write: "Working magic...",
};
const DEFAULT_STEP_LABEL = "Working magic...";
const THINKING_LABEL = "Thinking...";
const CHANGE_TYPES = new Set(["edit", "write"]);

const SPARKLE_PATHS = [
  "M5.01343 8.56433L4.53906 10.2246L4.0647 8.56433C3.81554 7.69229 3.13388 7.01063 2.26184 6.76147L0.601562 6.28711L2.26184 5.81274C3.13389 5.56359 3.81554 4.88193 4.0647 4.00989L4.53906 2.34961L5.01343 4.00989C5.26258 4.88193 5.94424 5.56359 6.81629 5.81274L8.47656 6.28711L6.81628 6.76147C5.94424 7.01063 5.26258 7.69229 5.01343 8.56433Z",
  "M9.94007 4.37059L9.78906 4.97461L9.63806 4.37059C9.46171 3.66522 8.91096 3.11446 8.20558 2.93811L7.60156 2.78711L8.20558 2.6361C8.91096 2.45976 9.46171 1.909 9.63806 1.20363L9.78906 0.599609L9.94007 1.20363C10.1164 1.909 10.6672 2.45976 11.3725 2.6361L11.9766 2.78711L11.3725 2.93811C10.6672 3.11446 10.1164 3.66522 9.94007 4.37059Z",
  "M9.14404 11.2847L8.91406 11.9746L8.68409 11.2847C8.55345 10.8928 8.24591 10.5852 7.85399 10.4546L7.16406 10.2246L7.85399 9.99463C8.24591 9.86399 8.55345 9.55645 8.68409 9.16454L8.91406 8.47461L9.14404 9.16454C9.27468 9.55645 9.58222 9.86399 9.97414 9.99463L10.6641 10.2246L9.97414 10.4546C9.58222 10.5852 9.27468 10.8928 9.14404 11.2847Z",
];

const isChange = (msg) =>
  CHANGE_TYPES.has(msg.displayText?.type) && msg.result?.success !== false;

function activeLabel(items) {
  if (!items.length) return THINKING_LABEL;
  const type = items[items.length - 1].displayText?.type;
  return STEP_LABELS[type] || DEFAULT_STEP_LABEL;
}

function doneLabel(items) {
  const changes = items.filter(isChange).length;
  const failed = items.filter((msg) => msg.result?.success === false).length;
  const base = changes
    ? `Made ${changes} ${changes === 1 ? "change" : "changes"}`
    : "Had a look around";
  return failed ? `${base}, ${failed} failed` : base;
}

const Spinner = () => (
  <svg
    className="tool-group-spinner"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25" />
    <path
      fill="currentColor"
      opacity="0.75"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

const Sparkles = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 13 13"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {SPARKLE_PATHS.map((d) => (
      <path key={d} d={d} />
    ))}
  </svg>
);

const Chevron = () => (
  <svg
    className="tool-group-chevron"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M3 4.5l3 3 3-3" />
  </svg>
);

function ToolGroup({ items, active }) {
  const [expanded, setExpanded] = useState(false);
  const label = active ? activeLabel(items) : doneLabel(items);

  return (
    <div className="tool-group" data-expanded={expanded}>
      <button
        type="button"
        className="tool-group-header"
        onClick={() => setExpanded(!expanded)}
        disabled={!items.length}
      >
        <span className="tool-group-icon">{active ? <Spinner /> : <Sparkles />}</span>
        <span key={label} className="tool-group-label">
          {label}
        </span>
        {items.length > 0 && <Chevron />}
      </button>
      {expanded && (
        <div className="tool-group-items">
          {items.map((msg) => (
            <div key={msg.toolCallId} className="tool-group-item">
              <ToolMessage data={msg.displayText} result={msg.result} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ToolGroup;
